import React from "react";

const AKPaginationButton = ({ isSelected, setPage, pageNumber }) => {
  const handleSetPage = () => {
    setPage(pageNumber);
  };
  return (
    <button
      className={`${isSelected && "current-selection"} page-button`}
      onClick={handleSetPage}
    >
      {pageNumber}
    </button>
  );
};

export default AKPaginationButton;
